<template>
  <div class="max-w-lg mx-auto p-4">
    <div class="flex justify-between items-center">
      <router-link :to="{ name: 'home' }"><img class="w-24" alt="Clue logo"
                                               src="../assets/logo.png"></router-link>
    </div>

    <p class="mt-6">
      Webform Gateway
    </p>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {}
};
</script>
